var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._b({staticClass:"pa-0"},'v-container',( _obj = {}, _obj[("grid-list-" + (_vm.$vuetify.breakpoint.name))] = true, _obj ),false),[_vm._l((_vm.$store.state.picturePoolGallery.images),function(item,index){return [(item)?_c('v-img',{key:'img-' + index,attrs:{"src":item,"lazy-src":item}}):_vm._e(),_c('v-divider',{key:'divider-' + index})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }